import { setUrlSearchParam } from "@/lib/navigation";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { atomWithReset } from 'jotai/utils';


/**
 * Action Modal (history item) Stuff
 * NOTE: copypasted from playerModal.ts
 */
export const actionModalOpenAtom = atomWithReset(false);
export const actionModalRefAtom = atomWithReset<string | undefined>(undefined);
export const actionModalFromPlayerAtom = atomWithReset(false);
export const actionModalUrlParam = 'actionModal';

//Helper to set the URL search param
export const setActionModalUrlParam = (ref: string | undefined) => {
    setUrlSearchParam(actionModalUrlParam, ref);
}

//Hook to open the action modal
export const useOpenActionModal = () => {
    const setModalRef = useSetAtom(actionModalRefAtom);
    const setModalOpen = useSetAtom(actionModalOpenAtom);
    const setFromPlayer = useSetAtom(actionModalFromPlayerAtom);
    return (actionId: string, opts?: { fromPlayerModal?: boolean }) => {
        setActionModalUrlParam(actionId);
        setModalRef(actionId);
        setFromPlayer(!!opts?.fromPlayerModal);
        setModalOpen(true);
    }
};

//Hook to close the action modal
export const useCloseActionModal = () => {
    const setModalOpen = useSetAtom(actionModalOpenAtom);
    return () => {
        setActionModalUrlParam(undefined);
        setModalOpen(false);
    }
};


//General hook for the state of the modal
export const useActionModalStateValue = () => {
    const actionRef = useAtomValue(actionModalRefAtom);
    const openedFromPlayerModal = useAtomValue(actionModalFromPlayerAtom);
    const [isModalOpen, setIsModalOpen] = useAtom(actionModalOpenAtom);
    return {
        isModalOpen,
        actionRef,
        openedFromPlayerModal,
        closeModal: () => {
            setActionModalUrlParam(undefined);
            setIsModalOpen(false);
        },
    }
}
